module.exports = __webpack_public_path__ + "static/media/6030.78b6317b.jpg";